const education = [
  {
    degree: "Bachelor of Science in Software Engineering",
    institution: "Bahir Dar University",
    institutionUrl: "https://www.bdu.edu.et/bit",
    program: "BiT",
    startDate: "05/2022",
    endDate: "05/2026",
    location: "Bahir Dar, Ethiopia",
    logoSrc: "/bdu_logo.jpg",
    highlights: [
      "Software Architecture & System Design",
      "Data Structures & Algorithms (DSA)",
      "Software Testing & Quality Assurance",
      "Web Development & Design",
      "Mobile Development & Design",
      "Database Management & Design",
      "Software Project Management",
    ],
  },
  {
    degree: "Fundamentals of programming",
    institution: "Udacity",
    institutionUrl: "https://www.udacity.com",
    program: "Online-Learning Platform",
    startDate: "09/2024",
    endDate: "12/2024",
    location: "Bahir Dar, Ethiopia",
    logoSrc: "/udacity_logo.png",
    highlights: [
      "Frontend & UI: JavaScript, HTML5, CSS3, with 15+ practical exercise.",
      "Version Control: Git, GitHub (10+ repositories managed).",
    ],
  },
];

export default education;
